<template>
  <div class="good pointer" :class="{ isRight: index % 4 == 0 }">
    <div class="good-head flex">
      <h3 class="ellipsis flex-1">
        {{ info.devicename }}
      </h3>
      <span><i class="el-icon-location"></i>{{ info.city }}</span>
    </div>
    <div class="flex">
      <img v-img="info.imgsrc" class="good-img" />
      <div class="good-info flex-1">
        <div class="flex" v-if="info.brand">
          <label>品牌：</label>
          <span>{{ info.brand }}</span>
          <label v-if="info.model">型号：</label>
          <span v-if="info.model">{{ info.model }}</span>
        </div>
        <div class="flex" v-if="info.pattern">
          <label>模式：</label>
          <span>{{ info.pattern }}</span>
        </div>
        <div class="flex" v-if="info.checkmallBusinessName">
          <label>店铺：</label
          ><span class="ellipsis">{{ info.checkmallBusinessName }}</span>
        </div>
        <div class="flex" v-if="info.functions">
          <label>功能：</label
          ><span class="ellipsis flex-1">{{ info.functions }}</span>
        </div>
      </div>
    </div>
    <div class="good-footer flex flex-between">
      <div class="good-price">
        <span class="good-prePrice" v-if="info.discount !== '10'">
          <span v-if="!info.preferentialPrice || info.face">面议</span>
          <span v-else
            >￥{{ info.preferentialPrice }}
            <i>/{{ unitMap[+info.unit] }}</i>
          </span>
        </span>
        <span
          class="good-oriPrice"
          v-if="info.discount"
          :class="{ noDis: info.discount == '10' }"
        >
          <span v-if="!info.minPrince || info.face">面议</span>
          <span v-else>￥{{ info.minPrince }} /{{ unitMap[+info.unit] }} </span>
        </span>
      </div>
      <div class="good-btn">
        <span @click.stop="toPay" class="pointer">在线下单</span>
        <span @click.stop="toDetail" class="pointer">查看详情</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      default: null,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    unitMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    toDetail() {
      this.$jump.push({ name: "deviceDetail", query: { id: this.info.id } });
    },
    toPay() {
      this.toDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.good {
  background: #ffffff;
  padding: 15px;
  &-img {
    text-align: center;
    width: 116px;
    height: 110px;
    object-fit: cover;
  }
  &-head {
    padding-bottom: 10px;
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
    h3 {
      text-align: left;
    }
    span {
      color: #ff9531;
      font-size: 14px;
    }
  }
  &-info {
    line-height: 26px;
    padding-left: 10px;
    label {
      color: #999;
      font-size: 14px;
      &:nth-child(3) {
        margin-left: 10px;
      }
    }
    span {
      max-width: 390px;
    }
  }
  &-footer {
    margin-top: 15px;
  }
  &-busi {
    padding: 0 33px;
    color: #202020;
    margin-bottom: 5px;
    text-align: center;
    width: 100%;
    i {
      color: #4483ff;
      font-size: 16px;
      position: relative;
      top: 1px;
      margin-right: 4px;
    }
  }
  &-brand {
    padding: 0 33px;
    color: #808080;
    margin-bottom: 5px;
  }
  &-model {
    max-width: 150px;
  }
  &-price {
    font-size: 16px;
    text-align: center;
    i {
      font-style: normal;
      font-size: 14px;
    }
  }
  &-prePrice,
  .noDis {
    color: #d10000;
    text-decoration: none;
    font-size: 24px;
  }
  &-oriPrice {
    margin-left: 20px;
    color: #808080;
    text-decoration: line-through;
  }
  &-btn {
    text-align: center;
    span {
      display: inline-block;
      padding: 8px 27px;
      color: white;
      background: $theme-color;
      border-radius: 4px;
      font-size: 14px;
      &:last-child {
        background: rgba($theme-color, 0.1);
        color: $theme-color;
        margin-left: 10px;
      }
    }
  }
}
</style>
